import vimeoFeature from '../widgets/tier-1-section/vimeoFeature.js';
import fairEventsFeed from '../widgets/tier-2-section/fairEventsFeed.js';
import * as fairSeoCardsSection from '../widgets/tier-3-section/index.js';
import fairHotButons from '../widgets/tier-4-section/fairHotButons.js';
import * as utils from '../../utils/utils.js';

let themeURL;

// -------------------------
// HEADER
function createHeader(sparkThemeConfig) {
  themeURL = sparkThemeConfig[0].navItemUrl;

  const mapIcon = `
    <defs>
    <style>
      .cls-1 {
        fill: #4f79bc;
      }

      .cls-2,
      .cls-3,
      .cls-4 {
        fill: none;
        stroke: #4f79bc;
        stroke-miterlimit: 10;
      }

      .cls-2 {
        stroke-width: 7px;
      }

      .cls-3,
      .cls-4 {
        stroke-width: 6px;
      }

      .cls-4 {
        stroke-dasharray: 7.98 10.97;
      }
    </style>
  </defs>
  <svg id="directions_icon"  data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 208.23 169.78">
    <path class="cls-1" d="M87.78,26.44C82.24,3,59.16,4.42,59.16,4.42,43.87,4.29,35,17.74,35,17.74c-9.89,16.88-.66,29.54-.66,29.54l8.57,13.06L59.43,87.76,84.75,47.81C90.46,37.74,87.78,26.44,87.78,26.44ZM59.43,48.07a17,17,0,1,1,17-17A17,17,0,0,1,59.43,48.07Z" transform="translate(-3.63 -4.41)"  ></path>
    <polyline class="cls-2" points="29.82 56.85 4.11 73.73 31.67 164.59 71.49 142.17 121.08 144.28 153.91 114.22 202.84 111.18 165.38 32.98 123.19 32.46 93.12 58.3 81.52 55.93"></polyline>  
    <line class="cls-2" x1="121.08" y1="144.28" x2="91.93" y2="56.72"></line>
    <path class="cls-3" d="M20.13,121.26s1.31.7,3.6,1.73" transform="translate(-3.63 -4.41)"></path>
    <path class="cls-4" d="M34,126.85c15.86,5,41.62,8.37,57-13.9L115.6,80.77S136.7,51.9,171,73.65l15.43,10.2" transform="translate(-3.63 -4.41)"></path>
    <line class="cls-3" x1="187.37" y1="82.47" x2="190.7" y2="84.68"></line>
  </svg>
  `;

  const themeHeading = 'fairground-header';
  $('.header').addClass(`${themeHeading}`);
  const search = $(`.${themeHeading} .searchBox`);
  const headerLogo = $(`.${themeHeading} .header-logo`);
  const navigation = $(`.${themeHeading} #mainNavigation`);
  const navToggle = $(`.${themeHeading} .mobile-nav-toggle`);
  const fairMap = $(`.${themeHeading} .header-map`);
  const fairLinks = $(`.${themeHeading} #static-top-links`);
  fairMap.append(mapIcon);

  $(`.${themeHeading}`).append(`
    <div class="fair-header-one">
      <div class="inner-content"></div>
    </div>
    <div class="fair-header-two">
      <div class="inner-content"></div>
    </div>
    <div class="fair-header-three">
      <div class="inner-content"></div>
    </div>
    `);

  $(`.${themeHeading} .fair-header-one .inner-content`).append(fairLinks);
  $(`.${themeHeading} .fair-header-two .inner-content`).append(search, fairMap);

  $(`.${themeHeading} .fair-header-three .inner-content`).append(
    `<div class="logo-container"></div>`,
    navigation,
    navToggle,
  );

  headerLogo.removeAttr('aria-label').attr({
    href: SITEBASEURL + themeURL,
    'aria-label': 'Indiana State Fairgrounds & Event Center',
  });

  $(`.${themeHeading} .fair-header-three .inner-content .logo-container`).append(headerLogo);

  $(`.${themeHeading} .headerInnerContent`).remove();
}

// -------------------------
// HOMEPAGE CONTENT
function createContent() {
  vimeoFeature();
  fairEventsFeed();
  fairSeoCardsSection.fairSeo();
  fairSeoCardsSection.fairMainCards();
  fairHotButons();

  $('.content').empty();
  $('.content').addClass('fairground-content');

  const contentStructure = `
      <div class="tier-1-container">
        <div class="inner-content"></div>
      </div>

      <div class="tier-2-container">
        <div class="inner-content"></div>
      </div>

      <div class="tier-3-container">
        <div class="inner-content"></div>
      </div>

      <div class="tier-4-container">
        <div class="inner-content"></div>
      </div>`;

  $('.fairground-content').append(contentStructure);

  const fairVideo = $('#vimeoFeature');
  const fairMainSlideshow = $('#fairSlideshow');
  const fairEvets = $('#fairEventsFeed');
  const fairSeoBlock = $('#fairSeo');
  const fairCards = $('#fairMainCards');
  const fairButtons = $('#fairHotButons');
  const fairMap = $('#fairMap');
  const fairSignup = $('#fairSignUp');

  $('.fairground-content .tier-1-container .inner-content').append(fairVideo, fairMainSlideshow);
  $('.fairground-content .tier-2-container .inner-content').append(fairEvets);
  $('.fairground-content .tier-3-container .inner-content').append(fairSeoBlock, fairCards);
  $('.fairground-content .tier-4-container .inner-content').append(
    fairButtons,
    fairMap,
    fairSignup,
  );

  $('#fairSignUp img').attr('src', bgImage);

  utils.showContent('fairground-content');
  $(globalThis).load(function () {
    $('.afterContent').remove();
  });
}

// -------------------------
// FOOTER
function createFooter() {
  const fairSocialSidebar = $('.footer .socialNetworks');
  const fairMediaBtn = $('.footer .btn-media-center');
  const navigation = $('.footer .footer-navigation');

  $('.footer').addClass('fairground_footer');
  $('.fairground-footer .fair-footer-logo').attr({
    href: themeURL,
    'aria-label': 'Indiana State Fairgrounds & Event Center',
  });
  $('.footer .fairground-footer .first-row').after(`<div class="second-row"></div>`);
  $('.footer .fairground-footer .second-row').append(fairSocialSidebar, fairMediaBtn);
  $('.footer .bottom-container .contact-details-footer').after(navigation);

  $('.footer .main-footer').remove();
}

export { createHeader, createContent, createFooter };
